import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.FIELD_OBSERVER;

export const MAP_GRID_SIZE = 4;
export const MAP_ZOOM_DURATION = 1000;

// number of times you can incorrectly answer a standard item before being kicked back to the map
export const MAX_WRONG_TRIES = 2;

// number of individual items you can fail before being kicked back to the progress screen.
export const ITEMS_FAILED_COUNT_FOR_LEVEL_FAIL = 2;

export const MAX_BADGES = 5;
export const CURIOSOS_SEEN_REQUIREMENT = 5; // the amount of unique curiosos you must zoom in on before you can complete a level.
export const BADGES_EARNED_REQUIREMENT = 4; // the amount of badges you must earn before you can complete a level.

export const WRONG_FEEDBACK_DURATION = 2000;

export const SLIDE_OUT_CAMERA_DURATION = 500;

export const BULLET_POINT_CHARACTER = '•';

export const CURRICULUM_VERSION = '2.0';

// increment this value if you need to change the shape of a user's save data
// in a way that will invalidate previous data.
// the saveDataReducer will automatically ignore any save data with a version lower than this value.
export const CURRENT_SAVE_DATA_VERSION = 5;

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD_VIEW: 'STANDARD_VIEW',
  LOADING: 'LOADING',
  MAP: 'MAP',
  PHOTO: 'PHOTO',
  PHOTO_ALBUM: 'PHOTO_ALBUM',
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  SET_SELECTED_INFERENCE_INDEX: 'SET_SELECTED_INFERENCE_INDEX',
  SET_LEVEL_INDEX: 'SET_LEVEL_INDEX',
  SELECT_CURIOSO: 'SELECT_CURIOSO',
  INITIALIZE_ITEM: 'INITIALIZE_ITEM',
  SET_SELECTED_MAP_CELL: 'SET_SELECTED_MAP_CELL',
  DISCARD_SELECTED_INFERENCE_CHOICE: 'DISCARD_SELECTED_INFERENCE_CHOICE',
  INCREMENT_SUBMITTED_ANSWERS_COUNT: 'INCREMENT_SUBMITTED_ANSWERS_COUNT',
  INCREMENT_WRONG_COUNT: 'INCREMENT_WRONG_COUNT',
  TOGGLE_EVIDENCE_SELECTION: 'TOGGLE_EVIDENCE_SELECTION',
  DISABLE_EVIDENCE: 'DISABLE_EVIDENCE',
  MARK_ITEM_AS_COMPLETE: 'MARK_ITEM_AS_COMPLETE',
  DESELECT_INFERENCE: 'DESELECT_INFERENCE',
  SET_IS_EVIDENCE_PANEL_SHAKING: 'SET_IS_EVIDENCE_PANEL_SHAKING',
  SHIFT_CURIOSO_POSITION: 'MOVE_CURIOSO_POSITION',
  MAKE_CURIOSO_ESCAPE: 'MAKE_CURIOSO_ESCAPE',
  REVEAL_CURIOSO: 'REVEAL_CURIOSO',
  HIDE_CURIOSO: 'HIDE_CURIOSO',
  DISABLE_SELECTED_INFERENCE_CHOICE: 'DISABLE_SELECTED_INFERENCE_CHOICE',
  SET_IS_MAP_ZOOMED: 'SET_IS_MAP_ZOOMED',
  SET_IS_MAP_ANIMATING_ZOOM: 'SET_IS_MAP_ANIMATING_ZOOM',
  MARK_ITEM_AS_PLAYED: 'MARK_ITEM_AS_PLAYED',
  MASTER_LEVEL: 'MASTER_LEVEL',
  SET_ALEX_STATE: 'SET_ALEX_STATE',
  SET_IS_INFERENCE_PANEL_DISCARDING: 'SET_IS_INFERENCE_PANEL_DISCARDING',
  SET_CURRENT_VO_PROMPT: 'SET_CURRENT_VO_PROMPT',
  SET_IS_RENDERING_HEADER_IN_ACTIVITY: 'SET_IS_RENDERING_HEADER_IN_ACTIVITY',
  SET_HAS_HEARD_SPECIFIC_PRAISE: 'SET_HAS_HEARD_SPECIFIC_PRAISE',
  CLEAR_SAVE_FOR_CURRENT_LEVEL: 'CLEAR_SAVE_FOR_CURRENT_LEVEL',
  CANCEL_STANDARD_ITEM: 'CANCEL_STANDARD_ITEM',
  QUICK_ROUND: 'QUICK_ROUND',

  ON_REVEAL_INFERENCE_CHOICES: 'ON_REVEAL_INFERENCE_CHOICES',
  ON_MIDDLE_OF_PHOTO_ANIMATION: 'ON_MIDDLE_OF_PHOTO_ANIMATION',
  ON_END_MIDDLE_OF_PHOTO_ANIMATION: 'ON_END_MIDDLE_OF_PHOTO_ANIMATION',

  SET_IS_DISABLING_TRANSITION_TO_STANDARD_ITEM: 'SET_IS_DISABLING_TRANSITION_TO_STANDARD_ITEM',
  SET_IS_DISABLING_NEXT_BUTTON_ON_NOTEBOOK: 'SET_IS_DISABLING_NEXT_BUTTON_ON_NOTEBOOK',
  SET_IS_DISABLING_NEXT_BUTTON_ON_INFERENCE_PANEL: 'SET_IS_DISABLING_NEXT_BUTTON_ON_INFERENCE_PANEL',
  SET_IS_DISABLING_INFERENCE_SELECTION: 'SET_IS_DISABLING_INFERENCE_SELECTION',
  SET_IS_DISABLING_EVIDENCE_SELECTION: 'SET_IS_DISABLING_EVIDENCE_SELECTION',
  SET_IS_DISABLING_DONE_BUTTON: 'SET_IS_DISABLING_DONE_BUTTON',
  SET_IS_DISABLING_TRANSITION_TO_MAP_SCREEN: 'SET_IS_DISABLING_TRANSITION_TO_MAP_SCREEN',
  SET_IS_DISABLING_CAMERA_BUTTON: 'SET_IS_DISABLING_CAMERA_BUTTON',
  SET_IS_DISABLING_COMPLETION_OF_PHOTO_ANIMATION: 'SET_IS_DISABLING_COMPLETION_OF_PHOTO_ANIMATION',
  SET_IS_ANIMATING_INFERENCE_TYPE_ICON: 'SET_IS_ANIMATING_INFERENCE_TYPE_ICON',
  SET_IS_ANIMATING_NEXT_BUTTON_ON_INFERENCE_PANEL: 'SET_IS_ANIMATING_NEXT_BUTTON_ON_INFERENCE_PANEL',
  SET_IS_ANIMATING_BADGE_CORRECT_INFERECE_CHOICE: 'SET_IS_ANIMATING_BADGE_CORRECT_INFERECE_CHOICE',
  SET_IS_HIGHLIGHTING_CORRECT_EVIDENCE: 'SET_IS_HIGHLIGHTING_CORRECT_EVIDENCE',
  SET_IS_ANIMATING_BADGE: 'SET_IS_ANIMATING_BADGE',
  END_ONBOARDING: 'END_ONBOARDING',
  RESTORE_MISSING_CURIOSOS: 'RESTORE_MISSING_CURIOSOS',

  INCREMENT_HELP_COUNT: 'INCREMENT_HELP_COUNT',
  UPDATE_RECORDS: 'UPDATE_RECORS',
};

export const ONBOARDING_TYPES = {
  NONE: 'NONE',
  FROM_QUESTION_MARK_BUTTON: 'FROM_QUESTION_MARK_BUTTON',
  FIRST_PLAY: 'FIRST_PLAY',
};

export const ONBOARDING_STEPS = {
  WAITING_FOR_USER_TO_ZOOM_IN_ON_MAP: 'WAITING_FOR_USER_TO_ZOOM_IN_ON_MAP',
  EXPLANATION_BEFORE_STANDARD_ITEM: 'EXPLANATION_BEFORE_STANDARD_ITEM',
  EXPLANATION_AT_START_OF_STANDARD_ITEM: 'EXPLANATION_AT_START_OF_STANDARD_ITEM',
  PROMPT_USER_TO_CHOOSE_INFERENCE: 'PROMPT_USER_TO_CHOOSE_INFERENCE',
  PROMPT_USER_TO_CHOOSE_EVIDENCE: 'PROMPT_USER_TO_CHOOSE_EVIDENCE',
  PROMPT_USER_TO_PRESS_DONE: 'PROMPT_USER_TO_PRESS_DONE',
  EXPLANATION_AT_START_OF_PHOTO_MOMENT: 'EXPLANATION_AT_START_OF_PHOTO_MOMENT',
  EXPLANATION_IN_MIDDLE_OF_PHOTO_MOMENT: 'EXPLANATION_IN_MIDDLE_OF_PHOTO_MOMENT',
  COMPLETE_ONBOARDING: 'COMPLETE_ONBOARDING',
};

export const ICON_TYPE = {
  CAMERA: 'CAMERA',
  NOTEBOOK: 'NOTEBOOK',
};

export const VO_PROMPTS = {
  NONE: 'NONE',

  // standard:
  SEE_WHAT_YOU_CAN_FIND_OUT: 'SEE_WHAT_YOU_CAN_FIND_OUT',
  LOOK_FOR_CURIOSOS: 'LOOK_FOR_CURIOSOS',
  READ_THE_PASSAGE: 'READ_THE_PASSAGE',
  READ_THE_QUESTION: 'READ_THE_QUESTION',
  SELECT_AN_INFERENCE: 'SELECT_AN_INFERENCE',
  SELECT_EVIDENCE: 'SELECT_EVIDENCE',
  PRESS_DONE: 'PRESS_DONE',
  TAKE_THE_PHOTO: 'TAKE_THE_PHOTO',
  YOU_FOUND_ONE: 'YOU_FOUND_ONE',
  CURIOSO_FLED_POSITIVE: 'CURIOSO_FLED_POSITIVE',
  CURIOSO_FLED_NEGATIVE: 'CURIOSO_FLED_NEGATIVE',
  CURIOSO_FLED_BUT_LEVEL_IS_COMPLETE: 'CURIOSO_FLED_BUT_LEVEL_IS_COMPLETE',
  INCORRECT_EVIDENCE: 'INCORRECT_EVIDENCE',
  INCORRECT_INFERENCE: 'INCORRECT_INFERENCE',
  INCORRECT_ALL: 'INCORRECT_ALL',
  CORRECT_ALL: 'CORRECT_ALL', // just triggers generic "you did it" audio
  CORRECT_ALL_SPECIFIC: 'CORRECT_ALL_SPECIFIC', // triggers VO that is specific to the inference type you just completed.
  GREAT_JOB_CURIOSO_MASTER: 'GREAT_JOB_CURIOSO_MASTER',
  ALREADY_FOUND_THAT_CURIOSO: 'ALREADY_FOUND_THAT_CURIOSO',
  WELCOME_BACK: 'WELCOME_BACK',
  LETS_GET_BACK: 'LETS_GET_BACK',

  // onboarding:
  ...ONBOARDING_STEPS,
};
